import { motion } from 'framer-motion';
import { LuX } from 'react-icons/lu';
import styled from 'styled-components';

export const BackgroundModal = styled(motion.div)`
    width: 100%;
    height: 100%;

    background: rgb(0, 0, 0, 0.6);
    position: fixed;
    z-index: 999;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    /* padding-top: 6rem; */

    @media (max-width: 768px) {
        padding-top: 0;
    }

    backdrop-filter: blur(2px);
`;

export const ModalWrapper = styled.div`
    max-width: 30rem;
    width: 100%;

    overflow-y: auto;
    box-shadow: 0 0.3125rem 1rem rgba(0, 0, 0, 0.2);
    background: ${({ theme }) => theme.colors.primary};
    color: #000;
    position: relative;
    z-index: 10001;
    border-radius: 1.25rem;
    clip-path: inset(0 round 1.25rem);
    padding: 1.5rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: content-box;

    p {
        font-weight: 600;
        font-size: 1.25rem;
    }

    @media (max-width: 1400px) {
        max-width: 40rem;
    }

    > .title {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        gap: 0.5rem;

        p.description {
            color: var(--Neutral-600, #52525b);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.975rem; /* 130% */
        }
    }

    gap: 1.5rem;

    .column {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        width: 100%;
    }
`;

export const AccordionItemContainer = styled(motion.button)`
    padding: 1.5rem 1rem;
    border-radius: 0.75rem;
    background: var(--Neutral-Opacity-200, rgba(228, 228, 231, 0.5));

    display: flex;
    flex-direction: column;
    cursor: pointer;
    border: none;
    

    .accordion-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        h2 {
            color: var(--Neutral-900, #18181b);
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 600;
            line-height: 1.05rem; /* 120% */
        }

        span.accordion-button {
            display: flex;
            svg {
                width: 1.5rem;
                height: 1.5rem;
            }
        }
    }

    .accordion-content {
        color: var(--Neutral-900, #18181b);
        font-size: 0.8125rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.05625rem; /* 130% */
        overflow: hidden;
        text-align: start;
    }
`;

export const CloseModalButton = styled(LuX)`
    cursor: pointer;
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
    width: 1.25rem;
    height: 1.25rem;
    padding: 0;
    z-index: 10;
    z-index: 10001;
`;
